module.exports = __webpack_public_path__ + "img/code_1.d702eab5.png";